/**
 * Custom React hook to fetch Amplience content by delivery key using Frontastic's callAction.
 * Provides a reusable and encapsulated way to handle Amplience API calls in the frontend.
 * Handles error scenarios gracefully and returns the content data if successful.
 */

import { useCallback } from 'react';
import { sdk } from 'sdk';

const useAmplience = () => {
  const getContentByDeliveryKey = useCallback(async (deliveryKey: string) => {
    if (!deliveryKey) {
      throw new Error('Delivery key is required');
    }

    const response = await sdk.callAction<any>({
      actionName: 'amplience/getContentByDeliveryKey',
      query: { deliveryKey },
    });

    if (response.isError) {
      const message =
        typeof response.error?.message === 'string' ? response.error.message : 'Failed to fetch Amplience content';
      throw new Error(message);
    }

    return response.data;
  }, []);

  return {
    getContentByDeliveryKey,
  };
};

export default useAmplience;
